import React from "react";
import PropTypes from "prop-types";
import { Menu, Button, Icon } from "semantic-ui-react";
import Aux from "../utility/Aux";
import OrganizerFileIcon from "../../modules/organizer/view/OrganizerFileIcon";

/**
 * FileMenuItem: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Tab item for open file in context bar
 * with an icon, title and optional close button.
 *
 * @param {*} props
 */
const FileMenuItem = props => (
  <Menu.Item
    active={
      props.currentDocument === props.document.id &&
      props.currentApplication === "/document"
    }
    content={
      <Aux>
        {/**
         * Returns the file type icon with width 16px (@2x: 32px)
         */}
        <OrganizerFileIcon
          documentType={props.document.documentType}
          size={16}
        />
        {/**
         * Displays the document name
         */}
        <span>{props.document.filename}</span>
        {/**
         * Renders a close button if one is set to exist
         */}
        {props.hasCloseButton ? (
          <Button compact basic icon size="mini" onClick={props.onClose}>
            <Icon name="close" />
          </Button>
        ) : null}
      </Aux>
    }
    name={props.document.id}
    onClick={props.onClick}
  />
);

FileMenuItem.propTypes = {
  /**
   * currentDocument: String
   * Currently open document (used to display if active)
   */
  currentDocument: PropTypes.string,
  /**
   * currentApplication: String
   * Currently open application
   */
  currentApplication: PropTypes.string.isRequired,

  /**
   * document: {id: String, filename: String, documentType: String}
   * Document to represent in this tab item
   */
  document: PropTypes.shape({
    id: PropTypes.string.isRequired,
    filename: PropTypes.string.isRequired,
    documentType: PropTypes.string.isRequired
  }).isRequired,

  /**
   * onClick: () => ()
   * On click handler for selecting the tab item
   */
  onClick: PropTypes.func.isRequired,

  /**
   * hasCloseButton: Boolean
   * Renders a close button if hovered over the tab item
   */
  hasCloseButton: PropTypes.bool,

  /**
   * onCLose: () => ()
   * On close handler for clicking the close button of the tab
   * bar item, if one exists through hasCloseButton
   */
  onClose: PropTypes.func
};

FileMenuItem.defaultProps = {
  currentDocument: null,

  hasCloseButton: false,
  onClose: () => {}
};

export default FileMenuItem;



// WEBPACK FOOTER //
// ./src/components/contextbar/FileMenuItem.js